import type {FetchOptions} from "ofetch";
interface ApiResponse<T> {
    success: boolean
    message: string
    data: T
    errors?: any[]
}


export default defineNuxtPlugin((nuxtApp) => {
    const config = useRuntimeConfig();


    const apiFetcher = $fetch.create({
        baseURL: config.public.baseUrl,
        timeout: 10000,
        retry: 2,
        retryDelay: 500,
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },

        async onRequest({ options, request }){
            const token = useCookie('auth_token')?.value;

            if (config.public.environment === 'dev'){
                options.headers.set('X-SABZLEARN-DEVELOPER', config.public.sabzlearnDeveloper)
            }
            if (import.meta.client){
                options.headers.set('X-Cart-Token', localStorage.getItem('uuid') ?? '')
            }
            if (token){
                options.headers.set('Authorization', `Bearer ${token}`)
            }
        },
        async onRequestError({ request, error, options }){
            if (import.meta.client) {
                if (options.retry && options.retry > 0) return;
                throw error
            }
            throw createError({
                statusCode: 503,
                message: 'خطا در ارتباط با سرور'
            })
        },
        async onResponseError({ response }){
            const errorData = {
                statusCode: response.status,
                message: response._data?.message || response._data?.error[0] || 'خطای نامشخصی رخ داد',
                data: response._data
            };

            switch (response.status) {
                case 401:
                    console.warn("Unauthorized - Redirecting ...")
                    return;
                case 404:
                    console.warn("404 Not Found - Redirecting ...")
                    nuxtApp.runWithContext(() => {
                        showError({
                            message: 'درخواست مورد نظر یافت نشد',
                            statusCode: 404
                        })
                    })
                    return;

                case 500:
                    nuxtApp.runWithContext(() => {
                        showError({
                            message: 'خطا از سمت سرور',
                            statusCode: 500
                        })
                    })
                default:
                    throw createError(errorData);
            }
        },
    })


    const api = <T = any>(url: string, options?: FetchOptions) => {
        return apiFetcher<ApiResponse<T>>(url, options as any);
    };

    return {
        provide: {
            api
        }
    }
})